var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 23,
    viewBox: "0 0 39 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.97099 17.7316L15.2231 21.2087C16.287 21.7735 17.7024 22.0915 19.1754 22.0966C20.6483 22.1016 22.0656 21.7934 23.1329 21.236L29.4055 17.8019C29.6348 17.6807 29.8178 17.5354 29.9439 17.3744C30.07 17.2135 30.1367 17.0402 30.1399 16.8646C30.1432 16.6889 30.0831 16.5146 29.9631 16.3516C29.843 16.1887 29.6655 16.0404 29.4408 15.9154C29.2161 15.7904 28.9488 15.6913 28.6544 15.6238C28.36 15.5563 28.0445 15.5217 27.7263 15.5222C27.408 15.5226 27.0934 15.558 26.8007 15.6263C26.5081 15.6946 26.2433 15.7945 26.0218 15.92L21.5706 18.3551L21.5817 2.26295C21.5828 1.91216 21.3312 1.57488 20.8825 1.32529C20.4337 1.0757 19.8244 0.934253 19.1887 0.932065C18.553 0.929878 17.943 1.06713 17.4927 1.31363C17.0425 1.56012 16.7889 1.89567 16.7879 2.24645L16.7769 18.3254L12.3658 15.873C11.9144 15.6306 11.3094 15.4952 10.6809 15.496C10.0524 15.4969 9.45084 15.6339 9.0057 15.8776C8.56056 16.1213 8.3075 16.4522 8.301 16.7989C8.29451 17.1457 8.53511 17.4806 8.97099 17.7316Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.1623,
    height: 38.3508,
    fill: "white",
    transform: "matrix(0.00297245 -0.999996 0.999994 0.00344089 0 22.0593)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/DownArrow.60a276e2bf4d897409a0dc302ee293a6.svg";
export { ForwardRef as ReactComponent };